import { Stack, useTheme } from "@mui/material";
import { EntitiesHeader } from "../EntitiesHeader";
import { SectionBox } from "@foodpilot/foods";
import { useProductMetadataContext } from "src/context/Product/Metadata/useProductMetadata";
import { useProductScoresContext } from "src/context/Product/Scores/useProductScores";
import { INGREDIENT, useFoodpilotContext, VIEW } from "src/context/FoodpilotContext";
import { Navigate } from "react-router";
import { URLHandler } from "src/services/URLHandler";
import { useCompanyMetadata } from "src/context/Company/Metadata/useCompanyMetadata";
import { useTranslation } from "react-i18next";
import { EntitiesData } from "../EntitiesData";
import { ProductIngredient } from "src/api/client-api/products/useGetOneProduct";
import { ProductIngredientDataRow } from "./ProductIngredientDataRow";
import { useEntityScoresOrUnavailable } from "src/context/Scores/useEntityScores";
import { Suspense } from "src/components/utils/Suspense";
import { ProductScoreChartColumn } from "../../ProductScoreChartColumn";

export const Ingredients = () => {
    const theme = useTheme();
    const { t } = useTranslation();
    const { canUser } = useFoodpilotContext();
    const { company } = useCompanyMetadata();
    const { product } = useProductMetadataContext();
    const { productSummary } = useProductScoresContext();
    const entityScores = useEntityScoresOrUnavailable();

    const isIntermediateProduct = product.isIntermediate === true;
    const urlHandlerRoutes = isIntermediateProduct ? URLHandler.intermediateProduct : URLHandler.product;

    const summaryUrl = urlHandlerRoutes.ssqSummary(company.id, product.id);
    if (!canUser(VIEW, INGREDIENT)) return <Navigate to={summaryUrl} replace />;

    return (
        <Stack gap={theme.spacing(2)}>
            <SectionBox
                header={
                    <EntitiesHeader
                        icon="ingredients"
                        title={t("menu.products.ingredients")}
                        count={product.productIngredients?.length ?? 0}
                        completion={productSummary?.ingredients?.completions.weightedAverage ?? 0}
                    />
                }
                borderRadius={4}
                sx={{ backgroundColor: "white" }}
            >
                <Stack direction={"row"} gap={3.5} sx={{ backgroundColor: "white" }}>
                    <Stack flex={5} gap={3}>
                        <Suspense isLoading={productSummary === null}>
                            <EntitiesData
                                key="ingredient-data"
                                productEntities={product.productIngredients ?? []}
                                entityDataRowHandler={(productIngredient: ProductIngredient) => (
                                    <ProductIngredientDataRow
                                        productIngredient={productIngredient}
                                        unit={entityScores.isAvailable ? entityScores.lastSelectedVariation.unit : ""}
                                    />
                                )}
                                noEntitiesMessage={t(
                                    "pas_d_ingredient_associe_a_ce_produit",
                                    "No ingredient associated with this product",
                                )}
                            />
                        </Suspense>
                    </Stack>

                    <ProductScoreChartColumn dimension="ingredients" />
                </Stack>
            </SectionBox>
        </Stack>
    );
};
